import { COMPANY } from "@/data/site";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <main data-testid="datenschutz-page" className="bg-ink-900 min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-32">
        <Link data-testid="datenschutz-back" to="/" className="inline-flex items-center gap-2 text-sm text-gold mb-10 hover:gap-3 transition-all">
          <ArrowLeft size={16} /> Zurück
        </Link>

        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Rechtliches</p>
        <h1 className="font-display text-5xl md:text-6xl text-white tracking-tight mb-12">
          Datenschutzerklärung.
        </h1>

        <div className="space-y-10 text-zinc-300 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">1. Verantwortlicher</h2>
            <p>{COMPANY.name}</p>
            <p>{COMPANY.ceo} (Geschäftsführer)</p>
            <p>{COMPANY.address.street}, {COMPANY.address.zip} {COMPANY.address.city}</p>
            <p>Telefon: {COMPANY.phone}</p>
            <p>E-Mail: {COMPANY.email}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">2. Allgemeine Hinweise</h2>
            <p>
              Wir nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst. Wir behandeln Ihre
              Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften (DSGVO,
              BDSG, TTDSG) sowie dieser Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">3. Erhebung und Speicherung personenbezogener Daten</h2>
            <p className="mb-3">
              Wenn Sie unser Kontaktformular nutzen, erheben wir folgende Daten:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer (optional)</li>
              <li>Auswahl der gewünschten Leistung</li>
              <li>Inhalt Ihrer Nachricht</li>
            </ul>
            <p className="mt-3">
              Diese Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage und für eventuelle
              Anschlussfragen verwendet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und f DSGVO.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">4. Auftragsverarbeiter</h2>
            <p>
              Für den Versand der per Kontaktformular eingehenden Nachrichten setzen wir
              <strong className="text-white"> Resend</strong> (Resend Inc., USA) ein. Resend
              verarbeitet die übermittelten Daten ausschließlich im Auftrag und nach Weisung des
              Verantwortlichen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">5. Speicherdauer</h2>
            <p>
              Wir speichern Ihre personenbezogenen Daten nur so lange, wie es für die Bearbeitung
              Ihrer Anfrage und etwaige Folgekontakte erforderlich ist, längstens jedoch für die
              Dauer der gesetzlichen Aufbewahrungsfristen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">6. Ihre Rechte</h2>
            <p>Sie haben jederzeit das Recht auf:</p>
            <ul className="list-disc pl-6 space-y-1 mt-3">
              <li>Auskunft (Art. 15 DSGVO)</li>
              <li>Berichtigung (Art. 16 DSGVO)</li>
              <li>Löschung (Art. 17 DSGVO)</li>
              <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Widerspruch (Art. 21 DSGVO)</li>
              <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
            </ul>
            <p className="mt-3">
              Bitte wenden Sie sich hierzu an die oben genannte Kontaktadresse.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">7. Cookies & lokale Speicherung</h2>
            <p>
              Diese Website verwendet ausschließlich <strong className="text-white">technisch
              notwendige</strong> Cookies bzw. lokale Speicherung (localStorage). Konkret wird
              lediglich gespeichert, ob Sie unseren Cookie-Hinweis bereits zur Kenntnis genommen
              haben, damit dieser Ihnen nicht erneut angezeigt wird.
            </p>
            <p className="mt-3">
              Wir setzen <strong className="text-white">keine</strong> Analyse-, Tracking- oder
              Marketing-Cookies ein. Es findet keine Profilbildung statt, es werden keine Daten an
              Drittanbieter (z.&nbsp;B. Google Analytics, Facebook Pixel) übermittelt.
            </p>
            <p className="mt-3">
              Rechtsgrundlage ist § 25 Abs. 2 Nr. 2 TTDSG (unbedingt erforderlich für die
              Diensterbringung). Sie können den Speicher jederzeit über die Einstellungen Ihres
              Browsers löschen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">8. Google Maps (auf Einwilligung)</h2>
            <p>
              Auf unserer Kontaktseite bieten wir die optionale Anzeige einer Standortkarte über
              <strong className="text-white"> Google Maps</strong> (Google Ireland Limited,
              Gordon House, Barrow Street, Dublin 4, Irland) an. Die Karte wird
              <strong className="text-white"> ausschließlich nach Ihrer ausdrücklichen Einwilligung</strong>
              {" "}geladen.
            </p>
            <p className="mt-3">
              Mit Aktivierung wird eine Verbindung zu Servern von Google hergestellt, wobei u.&nbsp;a.
              Ihre IP-Adresse, Browserinformationen und ggf. Standortdaten an Google übertragen werden.
              Eine Übertragung in Drittstaaten (USA) ist möglich. Rechtsgrundlage ist Art. 6 Abs. 1
              lit. a DSGVO sowie § 25 Abs. 1 TTDSG.
            </p>
            <p className="mt-3">
              Sie können Ihre Einwilligung jederzeit über den Cookie-Hinweis bzw. durch Löschen des
              Browser-Speichers widerrufen. Weitere Informationen finden Sie in den
              <a
                className="text-gold underline hover:no-underline ml-1"
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noreferrer noopener"
              >
                Datenschutzbestimmungen von Google
              </a>.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">9. Server-Log-Dateien</h2>
            <p>
              Der Provider der Seiten erhebt und speichert automatisch Informationen in
              Server-Log-Dateien (z. B. Browsertyp, Betriebssystem, Referrer-URL, Zugriffszeit).
              Diese Daten sind nicht bestimmten Personen zuordenbar und werden nicht mit anderen
              Datenquellen zusammengeführt.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">10. SSL-/TLS-Verschlüsselung</h2>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz vertraulicher Inhalte eine
              SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an
              "https://" und am Schloss-Symbol in der Browserzeile.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-gold-soft mb-3">11. Änderung dieser Datenschutzerklärung</h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie
              stets den aktuellen rechtlichen Anforderungen entspricht. Die jeweils aktuelle Fassung
              finden Sie auf dieser Seite.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
